/* Gift options — see snippets/purkal-gift-options.liquid.
   Listens at the document level because the cart drawer replaces its markup
   whenever the cart changes. Every change is saved to the cart's attributes
   (debounced), so nothing typed is lost when the drawer re-renders. */
(function () {
  'use strict';
  if (window.__pkGift) return;
  window.__pkGift = true;

  var timer = null;
  var attrTimer = null;
  var justClosed = false;

  function update(attrs) {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  /* Single fields outside the gift box (the WhatsApp number and email in
     snippets/purkal-cart-email.liquid). Pending values are pooled so moving
     from one field to the next within the debounce doesn't drop the first. */
  var pendingAttrs = {};
  function saveAttr(el) {
    if (el.getAttribute('aria-invalid') === 'true') mark(el);
    pendingAttrs[el.getAttribute('data-pk-attr')] = el.value.trim();
    clearTimeout(attrTimer);
    attrTimer = setTimeout(function () {
      var attrs = pendingAttrs;
      pendingAttrs = {};
      update(attrs);
    }, 400);
  }

  /* A gift needs a WhatsApp number; the email is optional but must be a real
     address if given. Checked on "Save & continue" and at checkout. */
  function valid(el) {
    var v = el.value.trim();
    if (!v) return !el.hasAttribute('data-pk-required');
    if (el.type === 'tel') return v.replace(/\D/g, '').length >= 10;
    return el.checkValidity();
  }

  // Shows or clears the field's error; returns whether it's valid.
  function mark(el) {
    var ok = valid(el);
    el.setAttribute('aria-invalid', ok ? 'false' : 'true');
    var err = el.parentNode.querySelector('[data-pk-err]');
    if (err) err.hidden = ok;
    return ok;
  }

  // The first missing field, or null when the gift is good to go.
  function missing(box) {
    var main = box.querySelector('[data-pk-gift-main]');
    if (!main || !main.checked) return null;
    var first = null;
    box.querySelectorAll('[data-pk-attr]').forEach(function (el) {
      if (!mark(el) && !first) first = el;
    });
    return first;
  }

  function collect(box) {
    var attrs = {};
    var gift = false;
    box.querySelectorAll('[data-pk-gift-field]').forEach(function (el) {
      var key = el.getAttribute('data-pk-gift-field');
      if (el.type === 'checkbox') {
        attrs[key] = el.checked ? 'Yes' : '';
        if (key === 'Gift') gift = el.checked;
      } else {
        attrs[key] = el.value.trim();
      }
    });
    // A postcard is wanted when they've written something on it.
    attrs['Postcard'] = attrs['Postcard message'] || attrs['Postcard from'] ? 'Yes' : '';
    // No gift: the postcard stays off the order.
    if (!gift) {
      attrs['Postcard'] = '';
      attrs['Postcard message'] = '';
      attrs['Postcard from'] = '';
    }
    return attrs;
  }

  function save(box) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      update(collect(box));
    }, 400);
  }

  function sync(box) {
    var main = box.querySelector('[data-pk-gift-main]');
    var area = box.querySelector('textarea');
    var count = box.querySelector('[data-pk-gift-count]');
    var summary = box.querySelector('[data-pk-gift-summary]');
    var quote = box.querySelector('[data-pk-gift-quote]');
    var edit = box.querySelector('[data-pk-gift-open]');
    var msg = area ? area.value.trim() : '';
    var shown = !!msg;
    if (count && area) count.textContent = area.value.length;
    if (summary && main) summary.hidden = !main.checked;
    if (quote) {
      quote.hidden = !shown;
      quote.textContent = msg.length > 60 ? msg.slice(0, 57) + '...' : msg;
    }
    if (edit) edit.textContent = shown ? 'Edit message' : 'Add a personalised message';
  }

  function open(box) {
    var dialog = box.querySelector('[data-pk-gift-dialog]');
    if (!dialog || dialog.open) return;
    if (dialog.showModal) dialog.showModal();
    else dialog.setAttribute('open', '');
    /* The browser focuses the first button — the close cross — and draws a
       focus box around it. Start on the panel instead. */
    var panel = dialog.querySelector('.pkg__panel');
    if (panel) {
      panel.setAttribute('tabindex', '-1');
      panel.focus({ preventScroll: true });
    }
  }

  function close(box) {
    var dialog = box.querySelector('[data-pk-gift-dialog]');
    if (!dialog) return;
    if (dialog.close) dialog.close();
    else dialog.removeAttribute('open');
  }

  function onChange(e) {
    var box = e.target.closest && e.target.closest('[data-pk-gift]');
    if (!box || !e.target.hasAttribute('data-pk-gift-field')) return;
    if (e.type === 'change' && e.target.hasAttribute('data-pk-gift-main') && e.target.checked) open(box);
    sync(box);
    save(box);
  }

  /* Capture phase, and stop the event there: the gift box sits inside the
     cart drawer's form, whose quantity checker would otherwise treat a tick
     or a keystroke here as a quantity change and show a false warning. */
  function capture(e) {
    if (e.target.hasAttribute && e.target.hasAttribute('data-pk-attr')) {
      saveAttr(e.target);
      e.stopPropagation();
      return;
    }
    if (!e.target.closest || !e.target.closest('[data-pk-gift]')) return;
    onChange(e);
    e.stopPropagation();
  }

  /* Cart attributes outlive the items, so an emptied cart would bring back
     last time's gift tick and message. Start every new cart unticked. */
  function reset() {
    update({ 'Gift': '', 'Postcard': '', 'Postcard message': '', 'Postcard from': '', 'Email for invoice': '', 'WhatsApp number': '' });
  }
  if (window.__pkGiftStale) reset();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData && event.cartData.item_count === 0) reset();
    });
  }

  document.addEventListener('change', capture, true);
  document.addEventListener('input', capture, true);

  document.addEventListener('click', function (e) {
    var box = e.target.closest && e.target.closest('[data-pk-gift]');
    if (!box) return;
    if (e.target.closest('[data-pk-gift-open]')) open(box);
    else if (e.target.closest('[data-pk-gift-save]')) {
      var bad = missing(box);
      if (bad) bad.focus();
      else close(box);
    }
    // A click on the dialog itself (not its panel) is a click on the backdrop.
    else if (e.target.closest('[data-pk-gift-close]') || e.target.hasAttribute('data-pk-gift-dialog')) close(box);
  });

  /* Hold checkout while a ticked gift is missing its email or phone, and
     reopen the pop-up at the missing field. Only the gift box that belongs to
     the submitted form counts (the cart page also carries the drawer). */
  document.addEventListener('submit', function (e) {
    if (!e.submitter || e.submitter.name !== 'checkout') return;
    var boxes = document.querySelectorAll('[data-pk-gift]');
    for (var i = 0; i < boxes.length; i++) {
      var main = boxes[i].querySelector('[data-pk-gift-main]');
      if (!main || main.form !== e.target) continue;
      var bad = missing(boxes[i]);
      if (!bad) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open(boxes[i]);
      bad.focus();
      return;
    }
  }, true);

  /* Escape closes the pop-up; keep that same key from also closing the cart
     drawer behind it. */
  document.addEventListener('keydown', function (e) {
    var dialog = e.key === 'Escape' && e.target.closest && e.target.closest('[data-pk-gift-dialog]');
    if (!dialog || !dialog.open) return;
    justClosed = true;
    setTimeout(function () { justClosed = false; }, 500);
  }, true);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && justClosed) e.stopPropagation();
  }, true);
})();
